const initialState = {
   isLoadingFiles: true,
   files: {},
   isMembership: false,
};

export default initialState;
